import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { Profile } from "@/models/Profile";

import CustomerGdprDefault from "./CustomerGdprDefault.vue";
import CustomerGdpRrekryteringslots from "./CustomerGdpRrekryteringslots.vue";
import CustomerGdprAgencyRecipient from "./CustomerGdprAgencyRecipient.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerGdpr',
  props: {
  company: {
    type: Profile,
    required: true,
  },
  // Namn på mottagande kundföretag för den aktuella annonsen. Tom => ingen
  // mottagarklausul. Kommer från positionens metadata via InputCheckbox2.
  recipientCompany: {
    type: String,
    required: false,
    default: "",
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      props.company.Container.DTO.id === 390 ||
      props.company.Container.DTO.id === 393
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(CustomerGdpRrekryteringslots, {
            company: props.company
          }, null, 8, ["company"])
        ]))
      : (
      props.company.Container.DTO.id !== 390 ||
      props.company.Container.DTO.id !== 393
    )
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(CustomerGdprDefault, {
              company: props.company
            }, null, 8, ["company"])
          ]))
        : _createCommentVNode("", true),
    (props.recipientCompany)
      ? (_openBlock(), _createBlock(CustomerGdprAgencyRecipient, {
          key: 2,
          company: props.company,
          "recipient-company": props.recipientCompany
        }, null, 8, ["company", "recipient-company"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})